import { IFinSobCheckItem } from 'legacy/lut/components/widgets/public/partner360/planning/models/IFinSobCheckItem'

import { finSobBaseValidationRules } from 'partner360/configs/p360Checks/finSobBaseValidationRules'

export const finSobPlanningValidationRules: IFinSobCheckItem[] = [
  ...finSobBaseValidationRules,
  {
    // Check SOB Actuals Quarterly: Compare SoB Actual same FQ SoB Targets
    key: 'jbp-planning-check-sob-actuals-quarterly',
    order: 3,
    isEnabled: true,
    current: { value: 'sob', type: 'actuals' },
    compareTo: { value: 'sob', type: 'targets' },
    thresholds: { warning: 5, error: 10 },
  },
]
